import { useCallback } from 'react';
import { useInternalRegulationObligationProcessesQuery } from '../graphql/queries/internalRegulationObligationProcesses.generated';
import { createObligationIdFilter } from './filterConstants';

const PAGE_SIZE = 25;

export const useObligationProcesses = (obligationId?: string) => {
  const { data, loading, error, fetchMore } = useInternalRegulationObligationProcessesQuery({
    variables: {
      first: PAGE_SIZE,
      input: {
        filters: {
          groups: obligationId ? [createObligationIdFilter(obligationId)] : [],
        },
      },
    },
    notifyOnNetworkStatusChange: true,
    skip: !obligationId,
  });

  const pageInfo = data?.internalRegulationObligationProcesses?.pageInfo;

  const handleFetchMore = useCallback(() => {
    if (pageInfo?.hasNextPage && !loading) {
      fetchMore({
        variables: {
          after: pageInfo.endCursor,
        },
      });
    }
  }, [pageInfo, loading, fetchMore]);

  const processes = data?.internalRegulationObligationProcesses?.edges.map((edge) => edge.node) ?? [];

  return { processes, loading, error, pageInfo, handleFetchMore };
};
